{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/accordion-panel",
	"title": "Accordion Panel",
	"category": "design",
	"description": "Contains the hidden or revealed content beneath the heading.",
	"parent": [ "core/accordion-item" ],
	"usesContext": [ "core/accordion-open-by-default" ],
	"supports": {
		"html": false,
		"color": {
			"background": true,
			"gradients": true
		},
		"interactivity": true,
		"spacing": {
			"padding": true,
			"blockGap": true,
			"__experimentalDefaultControls": {
				"padding": true,
				"blockGap": true
			}
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalDefaultControls": {
				"color": true,
				"radius": true,
				"style": true,
				"width": true
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"shadow": true,
		"layout": {
			"allowEditing": false
		},
		"visibility": false,
		"contentRole": true,
		"allowedBlocks": true,
		"lock": false
	},
	"attributes": {
		"templateLock": {
			"type": [ "string", "boolean" ],
			"enum": [ "all", "insert", "contentOnly", false ],
			"default": false
		}
	},
	"textdomain": "default",
	"style": "wp-block-accordion-panel"
}
